import { defineRecipe, defineSlotRecipe } from '@chakra-ui/react';

export const ButtonRecipe = defineRecipe({
   variants: {
      visual: {
         solid: {
            borderRadius: 'base',
            fontWeight: 'bold',
            bg: 'brand',
            color: 'black',
            fontSize: 'md',
            h: '14',
            px: '10',
         },
         plain: {
            borderWidth: '2px',
            borderColor: 'white',
            borderRadius: '4xl',
            fontWeight: 'medium',
            bg: 'white',
            color: 'black',
            fontSize: 'xs',
            px: '3',
            h: '10',
            minW: '73px',
            textTransform: 'uppercase',
            letterSpacing: 'xs',
            _hover: {
               bg: 'brand',
               borderColor: 'brand',
            },
         },
      },
   },
   defaultVariants: {
      visual: 'solid',
   },
});

export const CheckboxRecipe = defineSlotRecipe({
   slots: ['root'],
   base: {
      root: {
         '& > div': {
            h: '6',
            w: '6',
            borderRadius: 'md',
            borderColor: 'gray.500',
            borderWidth: '2px',
         },
         _checked: {
            '& > div': { bg: 'brand', borderColor: 'brand' },
         },
      },
   },
});
